var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.currentJewelSelection
      ? _c("div", [
          _vm.options &&
          _vm.options.length > 0 &&
          _vm.currentJewelSelection.productType !== "KIT"
            ? _c(
                "div",
                _vm._l(_vm.options, function(option, index) {
                  return _c(
                    "div",
                    { key: option.id, staticClass: "col-12 mb-3" },
                    [
                      _c("div", { staticClass: "option-label border-left-0" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-right info-button-parent-product align-self-center"
                          },
                          [
                            _vm.currentJewelSelection.productType ===
                              "EXHIBITORS" &&
                            _vm.$te("tooltip-" + option.type + "-exhibitors")
                              ? _c(
                                  "v-popover",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      popoverClass:
                                        "tooltip-custom d-inline-block",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "info-button cursor-pointer",
                                      attrs: { icon: ["fas", "info-circle"] }
                                    }),
                                    _c(
                                      "template",
                                      { slot: "popover" },
                                      [
                                        _c("JewelDescriptionTooltip", {
                                          attrs: {
                                            description: _vm.$t(
                                              "tooltip-" +
                                                option.type +
                                                "-exhibitors"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-left pl-5 text-uppercase label-menu"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "option-" +
                                      _vm.currentJewelSelection.productType +
                                      "-" +
                                      "" +
                                      option.type
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "pl-5 pt-2" }, [
                        _c("div", { staticClass: "select-wrapper" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.skuSelection[index],
                                  expression: "skuSelection[index]"
                                }
                              ],
                              staticClass: "w-100 select-setting",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.skuSelection,
                                      index,
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.skuComposition(
                                      _vm.skuSelection[index],
                                      index
                                    )
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { domProps: { value: "null" } }),
                              _vm._l(option.values, function(val) {
                                return _c(
                                  "option",
                                  {
                                    key: val.id,
                                    attrs: { disabled: val.disabled },
                                    domProps: { value: val.id }
                                  },
                                  [_vm._v(" " + _vm._s(val.label) + " ")]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.currentJewelSelection &&
          _vm.currentJewelSelection.productType === "PACKAGING"
            ? _c("div", { staticClass: "col-12 mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "option-label row",
                    staticStyle: { "border-left": "none !important" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "\n            col-10\n            pl-0\n            d-inline-block\n            position-relative\n            align-self-center\n          "
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("frame")) + " ")]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "col-2 pl-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.frame,
                            expression: "frame"
                          }
                        ],
                        staticClass: "w-100 pt-1 checkbox-setting",
                        attrs: {
                          type: "checkbox",
                          disabled: !_vm.jewelDescription
                        },
                        domProps: {
                          checked: Array.isArray(_vm.frame)
                            ? _vm._i(_vm.frame, null) > -1
                            : _vm.frame
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.frame,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.frame = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.frame = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.frame = $$c
                              }
                            },
                            _vm.selectionFrame
                          ]
                        }
                      })
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm.currentJewelSelection &&
          _vm.currentJewelSelection.productType == "PACKAGING"
            ? _c("div", { staticClass: "col-12 mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "option-label row",
                    staticStyle: { "border-left": "none !important" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "\n            col-10\n            pl-0\n            d-inline-block\n            position-relative\n            align-self-center\n          "
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("engraveYourLogoProduct")) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "col-2 pl-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.logo,
                            expression: "logo"
                          }
                        ],
                        staticClass: "w-100 pt-1 checkbox-setting",
                        attrs: {
                          type: "checkbox",
                          disabled: !_vm.jewelDescription
                        },
                        domProps: {
                          checked: Array.isArray(_vm.logo)
                            ? _vm._i(_vm.logo, null) > -1
                            : _vm.logo
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.logo,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.logo = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.logo = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.logo = $$c
                              }
                            },
                            function($event) {
                              return _vm.logoSelection()
                            }
                          ]
                        }
                      })
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm.currentJewelSelection &&
          _vm.currentJewelSelection.productType == "KIT" &&
          _vm.jewelDescription &&
          _vm.currentJewelSelection.options[0].values.length != 1
            ? _c("div", { staticClass: "col-12 mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "option-label mb-3",
                    staticStyle: { "border-left": "none !important" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "\n            col-10\n            pl-0\n            d-inline-block\n            position-relative\n            align-self-center\n          "
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("addExhibitors")) + " ")]
                        )
                      ]
                    ),
                    _c("div", { staticClass: "col-2 pl-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.exhibitor,
                            expression: "exhibitor"
                          }
                        ],
                        staticClass: "w-100 pt-1 checkbox-setting",
                        attrs: {
                          type: "checkbox",
                          disabled:
                            !_vm.jewelDescription ||
                            _vm.currentJewelSelection.options[0].values
                              .length === 1
                        },
                        domProps: {
                          checked: Array.isArray(_vm.exhibitor)
                            ? _vm._i(_vm.exhibitor, null) > -1
                            : _vm.exhibitor
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.exhibitor,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.exhibitor = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.exhibitor = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.exhibitor = $$c
                              }
                            },
                            function($event) {
                              return _vm.exhibitorSelection(_vm.exhibitor)
                            }
                          ]
                        }
                      })
                    ])
                  ]
                ),
                _vm.selectedProduct.optionPrice &&
                _vm.selectedProduct.optionPrice[0].logoPrice
                  ? _c(
                      "div",
                      {
                        staticClass: "option-label",
                        staticStyle: { "border-left": "none !important" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-10 pl-0 d-inline-block position-relative"
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("engraveYourLogo")) + "* "
                                ),
                                _c(
                                  "v-popover",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      popoverClass:
                                        "tooltip-custom d-inline-block",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "info-button cursor-pointer",
                                      attrs: { icon: ["fas", "info-circle"] }
                                    }),
                                    _c(
                                      "template",
                                      { slot: "popover" },
                                      [
                                        _c("JewelDescriptionTooltip", {
                                          attrs: {
                                            description: _vm.$t(
                                              "tooltipEngraveYourLogo"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm.currentJewelSelection &&
                            _vm.selectedProduct.optionPrice[0].logoPrice &&
                            _vm.retailPerc === 1
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-left pl-5 incisione-label"
                                  },
                                  [
                                    _vm._v(
                                      " ( " +
                                        _vm._s(_vm.$t("addLogo")) +
                                        " + " +
                                        _vm._s(
                                          _vm.selectedProduct.optionPrice[0].logoPrice
                                            .toFixed(2)
                                            .replace(".", ",")
                                        ) +
                                        "€) "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " *" +
                                        _vm._s(_vm.$t("onlyForRings")) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _c("div", { staticClass: "col-2 pl-0" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.logo,
                                expression: "logo"
                              }
                            ],
                            staticClass: "w-100 pt-1 checkbox- d-flex",
                            attrs: {
                              type: "checkbox",
                              disabled: !_vm.jewelDescription
                            },
                            domProps: {
                              checked: Array.isArray(_vm.logo)
                                ? _vm._i(_vm.logo, null) > -1
                                : _vm.logo
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.logo,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 && (_vm.logo = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.logo = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.logo = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.logoSelection()
                                }
                              ]
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.selectedProduct.optionPrice &&
                _vm.selectedProduct.optionPrice[0].warrantyPrice
                  ? _c(
                      "div",
                      {
                        staticClass: "option-label row",
                        staticStyle: { "border-left": "none !important" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-10 pl-0 d-inline-block position-relative"
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("printWarranties")) + " "
                                ),
                                _c(
                                  "v-popover",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      popoverClass:
                                        "tooltip-custom d-inline-block",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "info-button cursor-pointer",
                                      attrs: { icon: ["fas", "info-circle"] }
                                    }),
                                    _c(
                                      "template",
                                      { slot: "popover" },
                                      [
                                        _c("JewelDescriptionTooltip", {
                                          attrs: {
                                            description: _vm.$t(
                                              "tooltipWarranty"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm.currentJewelSelection &&
                            _vm.selectedProduct.optionPrice[0].warrantyPrice &&
                            _vm.retailPerc === 1
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-left pl-5 incisione-label"
                                  },
                                  [
                                    _vm._v(
                                      " ( " +
                                        _vm._s(_vm.$t("addWarranties")) +
                                        " + " +
                                        _vm._s(
                                          _vm.selectedProduct.optionPrice[0].warrantyPrice
                                            .toFixed(2)
                                            .replace(".", ",")
                                        ) +
                                        "€) "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _c("div", { staticClass: "col-2 pl-0" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.warranty,
                                expression: "warranty"
                              }
                            ],
                            staticClass: "w-100 pt-1 checkbox- d-flex",
                            attrs: {
                              type: "checkbox",
                              disabled: !_vm.jewelDescription
                            },
                            domProps: {
                              checked: Array.isArray(_vm.warranty)
                                ? _vm._i(_vm.warranty, null) > -1
                                : _vm.warranty
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.warranty,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.warranty = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.warranty = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.warranty = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.warrantySelection()
                                }
                              ]
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }